var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c("form-detail-include", { attrs: { id: _vm.id } }),
          _c("comments-include", {
            attrs: {
              newsletterId: _vm.id,
              comments: _vm.comments,
              showHandling: true
            },
            on: {
              "update:comments": function($event) {
                _vm.comments = $event
              }
            }
          }),
          _c(
            "div",
            { staticClass: "w-full flex gap-2 justify-end" },
            [
              _c(
                "b-button",
                {
                  staticClass: "float-right",
                  attrs: { variant: "outline-secondary" },
                  on: { click: _vm.goBack }
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "CornerUpLeftIcon" }
                  }),
                  _c("span", { staticClass: "align-middle" }, [
                    _vm._v(_vm._s(_vm.$t("back")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }